import {
  IDeleteImageInput,
  InputUploadLogos,
  IResponseImageUploader,
  IStorageService,
} from '@/services/contracts/storage'
import api, { HttpResponse, treatmentForErrors } from '../api'

export class StorageService implements IStorageService {
  async uploadLogo({
    institution_id,
    file,
    route,
  }: InputUploadLogos): Promise<HttpResponse<{ url: string }, Error>> {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }
    const formData = new FormData()
    formData.append('logo', file)
    const request = api.put(
      `/admin/institutions/${institution_id}/${route}`,
      formData,
      { headers },
    )
    return treatmentForErrors(request)
  }

  async uploadImage(
    institution_id: string,
    file: File,
  ): Promise<HttpResponse<IResponseImageUploader, Error>> {
    const headers = {
      'Content-Type': 'multipart/form-data',
    }
    const formData = new FormData()
    formData.append('image', file)
    const request = api.post(
      `/admin/institutions/${institution_id}/images`,
      formData,
      { headers },
    )
    return treatmentForErrors(request)
  }

  async downloadFile(filename: string) {
    if (!filename)
      return [{ url: '' }, null] as HttpResponse<{ url: string }, unknown>
    const name = filename?.replace(/\/+/g, '-')
    const request = api.get(`/storage/${name}`)
    return treatmentForErrors(request)
  }

  async deleteImage({ image_id, institution_id }: IDeleteImageInput) {
    const request = api.delete(
      `/admin/institutions/${institution_id}/images/${image_id}`,
    )
    return treatmentForErrors(request)
  }
}
